import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";
import "../styles/NewProducts.css";
import ContactForm from "../components/ContactForm";

const Products = () => {
  const { partnerId } = useParams();
  const [productGroups, setProductGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("--- USING PARTNER ID ---", partnerId);
    const fetchPartnersAndProducts = async () => {
      try {
        let query = supabase
          .from("partners")
          .select(
            `
            *,
            products (*)
          `
          )
          .order("name");

        // If partnerId is provided, filter for specific partner by UUID
        if (partnerId) {
          query = query.eq("id", partnerId);
        }

        const { data: partnersData, error: partnersError } = await query;

        if (partnersError) throw partnersError;

        // Transform the data to match the component's structure
        const transformedData = partnersData
          .filter((partner) => {
            // If we have a partnerId, only include that partner
            if (partnerId) {
              return true; // We already filtered by UUID in the query
            }
            // Otherwise, include all partners with products
            return partner.products && partner.products.length > 0;
          })
          .map((partner) => ({
            title: partner.name,
            bannerImage: partner.banner_url,
            products: [
              {
                title: partner.name + " Products",
                description: partner.description,
                categories: partner.products.map((product) => ({
                  title: product.title,
                  description: product.description || "",
                  image: product.image_url,
                  link: product.product_link,
                  pdf: product.download_link,
                  filename: product.download_link.split("/").pop(),
                })),
              },
            ],
          }));

        if (partnerId && transformedData.length === 0) {
          throw new Error(`No products found for partner ID: ${partnerId}`);
        }

        setProductGroups(transformedData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPartnersAndProducts();
  }, [partnerId]); // Add partnerId as dependency

  if (loading) {
    return (
      <div className="products">
        <div className="loading-container">
          <p>Loading products...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="products">
        <div className="error-container">
          <p>Error loading products: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="products">
      {productGroups.map((productGroup, groupIndex) => (
        <div className="products__group" key={groupIndex}>
          <div className="products__container">
            <div
              className="products__header"
              style={{ backgroundImage: `url(${productGroup.bannerImage})` }}
            >
              <div className="products__overlay"></div>
            </div>

            <div className="products__content">
              {productGroup.products.map((product, productIndex) => (
                <div className="products__section" key={productIndex}>
                  <h3 className="products__title">{product.title}</h3>
                  <p className="products__description">{product.description}</p>

                  <div className="products__categories">
                    {product.categories.map((category, catIndex) => (
                      <div className="products__card" key={catIndex}>
                        <div className="products__image-container">
                          <img
                            src={category.image || "/placeholder.svg"}
                            alt={category.title}
                            className="products__image"
                          />
                        </div>
                        <div className="products__card-content">
                          <h4 className="products__card-title">
                            {category.title}
                          </h4>
                          <div className="button-row">
                            <a
                              href={category.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="products__link"
                            >
                              View product
                            </a>
                            <a
                              href={category.pdf}
                              download={category.filename}
                              className="download_pdf"
                            >
                              Download PDF
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      <ContactForm />
    </div>
  );
};

export default Products;
